module.exports = __webpack_public_path__ + "img/real-estate01.f4758c1d.png";